import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import TrainingDialog from "@/ui_components/TrainingDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingCard',
  props: ["title", "description", "image", "trainingId"],
  setup(__props) {

const isDialogOpened = ref(false);
const openTrainingDialog = () => {
  isDialogOpened.value = true;
};

const closeSelf = () => {
  isDialogOpened.value = false;
};

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "h-32 rounded-3xl border-2 bg-amber-100 p-3",
      onClick: openTrainingDialog
    }, [
      _createElementVNode("h1", null, _toDisplayString(props.title), 1),
      _createElementVNode("p", null, _toDisplayString(props.description), 1)
    ]),
    (isDialogOpened.value)
      ? (_openBlock(), _createBlock(TrainingDialog, {
          key: 0,
          trainingId: props.trainingId,
          onCloseSelf: closeSelf
        }, null, 8, ["trainingId"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})